<template>
    <div>
        <!-- Modal de Item da Tabela -->
        <div class="modal fade" id="itemModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            <span v-if="itemTabela">
                                Valor
                                {{ ( itemTabela.id_item_tabela || itemTabela.id_propria ) ? '' : '(Novo)' }}
                                <span class="badge badge-secondary ml-2" v-if="itemTabela.id_item_tabela">#{{ itemTabela.id_item_tabela }}</span>
                                <span class="badge badge-secondary ml-2" v-if="itemTabela.id_propria">#{{ itemTabela.id_propria }}</span>
                            </span>
                            <span v-else>
                                Carregando...
                            </span>
                        </h5>
                        <button type="button" class="close" @click="fechar_modal('itemModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <az-empty-state v-if="!itemTabela" />

                        <template v-if="itemTabela">

                            <az-sub-title :title="'Tabela: ' + tabela.search">
                                <a href="#" @click.prevent="$util.abrirTabela(tabela)">
                                    <i class="fas fa-list"></i>
                                </a>
                            </az-sub-title>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Descrição"
                                        required
                                        :validate="validate"
                                        v-model="itemTabela.st_nome"
                                        v-if="tabela.st_aplicacao != 'MIX'" />

                                    <az-input
                                        sizing="sm"
                                        label="Descrição"
                                        required
                                        :validate="validate"
                                        v-model="itemTabela.st_descricao"
                                        v-else />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Código"
                                        required
                                        :validate="validate"
                                        v-model="itemTabela.st_codigo" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Código de autorização"
                                        :placeholder="itemTabela.st_codigo"
                                        :validate="validate"
                                        v-model="itemTabela.st_codigo_autorizacao" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Código para guia impressa"
                                        :placeholder="itemTabela.st_codigo"
                                        :validate="validate"
                                        v-model="itemTabela.st_codigo_guia_impressa" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col col-12" :class="tabela.st_aplicacao == 'PRO' ? 'col-md-8' : ''">
                                    <az-input
                                        sizing="sm"
                                        label="Observação"
                                        :validate="validate"
                                        v-model="itemTabela.st_observacoes" />
                                </div>
                                <div class="col col-12 col-md-4" v-if="tabela.st_aplicacao == 'PRO'">
                                    <az-input
                                        label="Especialidade (CBO)"
                                        sizing="sm"
                                        type="select"
                                        optionsMode="aql"
                                        service="especialidades.index"
                                        optionsData="id_especialidade"
                                        optionsDisplay="search"
                                        v-model="itemTabela.id_especialidade"
                                        placeholder="Padrão do Procedimento..."
                                        :validate="validate" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        sizing="sm"
                                        label="Código da Tabela"
                                        type="select"
                                        optionsMode="aql"
                                        service="codigo_tabelas.index"
                                        optionsData="id_codigo_tabela"
                                        optionsDisplay="search"
                                        v-model="itemTabela.id_codigo_tabela"
                                        :validate="validate"  />
                                    <!-- v-if="tabela.st_aplicacao != 'MIX'" -->
                                </div>

                                <div class="col col-12 col-md-4" v-if="tabela.st_aplicacao == 'PRO'">
                                    <az-input
                                        label="Grau de Participação"
                                        sizing="sm"
                                        type="select"
                                        optionsMode="aql"
                                        service="grau_participacoes.index"
                                        optionsData="id_grau_participacao"
                                        optionsDisplay="search"
                                        v-model="itemTabela.id_grau_participacao"
                                        placeholder="Padrão..."
                                        :validate="validate" />
                                </div>
                            </div>

                            <div class="form-row" v-if="tabela.st_aplicacao != 'PRO'">
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        sizing="sm"
                                        label="Código da Despesa"
                                        type="select"
                                        optionsMode="aql"
                                        service="codigo_despesa.index"
                                        optionsData="id_codigo_despesa"
                                        optionsDisplay="search"
                                        v-model="itemTabela.id_codigo_despesa"
                                        :validate="validate"  />
                                </div>

                                <div class="col col-12 col-md-4" v-if="tabela.st_aplicacao == 'MIX'">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade de Medida (TISS)"
                                        placeholder="Padrão do Item..."
                                        :validate="validate"
                                        type="select"
                                        optionsMode="aql"
                                        service="unidade_medidas.index"
                                        optionsData="id_unidade_medida"
                                        optionsDisplay="search"
                                        v-model="itemTabela.id_unidade_medida" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="money"
                                        label="Valor"
                                        :validate="validate"
                                        :edicao="!itemTabela.item_tabela_preco || !itemTabela.item_tabela_preco.fl_ativo"
                                        :precision="tabela.st_aplicacao == 'MIX' ? 6 : 2"
                                        v-model="itemTabela.dc_valor" />

                                    <!-- Ajuste programado -->
                                    <small class="text-muted"
                                        v-if="itemTabela.item_tabela_preco && itemTabela.item_tabela_preco.fl_ativo && itemTabela.item_tabela_preco.dt_vigencia_inicio > $util.hoje()">
                                        {{ $util.formatMoeda(itemTabela.item_tabela_preco.dc_valor) }} a partir de {{ $util.getFormatDate(itemTabela.item_tabela_preco.dt_vigencia_inicio) }}
                                    </small>
                                </div>
                                <template v-if="tabela.st_aplicacao != 'MIX'">
                                    <div class="col col-12 col-md-4" v-if="!tabela.fl_moeda_corrente">
                                        <az-input
                                            sizing="sm"
                                            type="button-group"
                                            label="Moeda Corrente (R$)"
                                            :optionsList="[
                                                { id: 'S', search: 'Sim' },
                                                { id: 'N', search: 'Não' },
                                            ]"
                                            v-model="itemTabela.moeda_corrente" />
                                    </div>
                                    <div class="col col-12 col-md-4" v-if="!tabela.fl_moeda_corrente && itemTabela.moeda_corrente == 'N'">
                                        <az-input
                                            sizing="sm"
                                            label="Moeda"
                                            required
                                            :validate="validate"
                                            type="select"
                                            optionsMode="aql"
                                            service="moedas.index"
                                            :optionsParm="{ where: { id_tabela_versao: tabela.id_tabela_versao }}"
                                            optionsData="id_moeda"
                                            optionsDisplay="search"
                                            :optionsReload="true"
                                            v-model="itemTabela.id_moeda" />
                                    </div>
                                </template>

                                <template v-else-if="tabela.st_aplicacao == 'MIX'">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="number"
                                            label="Casas Decimais Valor Unitário"
                                            placeholder="Padrão..."
                                            v-model="itemTabela.in_casas_decimais" />
                                    </div>
                                </template>
                            </div>

                            <!-- Fator de Cobrança -->
                            <div class="mb-3" v-if="itemTabela.id_propria">
                                <az-sub-title title="Conversão de Quantidade para Cobrança (Suprimentos)"></az-sub-title>
                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            label="Tipo de Conversão"
                                            sizing="sm"
                                            type="select"
                                            :optionsList="[
                                                { id: 'M', search: 'Multiplicação' },
                                                { id: 'D', search: 'Divisão' },
                                            ]"
                                            optionsData="id"
                                            v-model="itemTabela.ch_conversao_qt_cobranca" />
                                    </div>
                                    <template v-if="itemTabela.ch_conversao_qt_cobranca">
                                        <div class="col col-12 col-md-4">
                                            <az-input 
                                                label="Fator"
                                                sizing="sm"
                                                type="number"
                                                placeholder="Fator..."
                                                v-model="itemTabela.dc_fator_cobranca" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input 
                                                label="Casas Decimais"
                                                sizing="sm"
                                                type="number"
                                                placeholder="Casas Decimais..."
                                                v-model="itemTabela.in_conversao_cobranca_decimais" />
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <!-- Atualização Simpro / Brasíndice -->
                            <div class="form-row" v-if="itemTabela.id_propria">
                                <div class="col col-12">
                                    <az-sub-title title="Atualização de Preço"></az-sub-title>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Tipo de atualização"
                                        :validate="validate"
                                        type="select"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        :optionsList="[
                                            { id: 'B', search: 'Brasíndice' },
                                            { id: 'S', search: 'Simpro' },
                                        ]"
                                        v-model="itemTabela.ch_tipo_atualizacao" />
                                </div>
                                
                                <div class="col col-12 col-md-3" v-if="itemTabela.ch_tipo_atualizacao == 'B'">
                                    <az-input
                                        type="select"
                                        sizing="sm"
                                        optionsMode="aql"
                                        optionsSync2="false"
                                        service="tabela_versaos.index"
                                        optionsData="id_tabela_versao"
                                        :optionsParm="{ brasindice: true }"
                                        optionsName="tabela_versaos.index.brasindices"
                                        :optionsReload="true"
                                        label="Seleciona a versão"
                                        v-model="id_tabela_versao_bra"
                                        @input="itemTabela.id_brasindice = null"
                                    />
                                </div>
                                <div class="col col-12 col-md-7" v-if="itemTabela.ch_tipo_atualizacao == 'B'">
                                    <az-input
                                        sizing="sm"
                                        label="Brasíndice"
                                        placeholder="Selecione o item..."
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="brasindices.index"
                                        optionsData="id_brasindice"
                                        :optionsParm="{ ativos: true, id_tabela_versao: id_tabela_versao_bra }"
                                        v-model="itemTabela.id_brasindice" />
                                </div>

                                <div class="col col-12 col-md-3" v-if="itemTabela.ch_tipo_atualizacao == 'S'">
                                    <az-input
                                        type="select"
                                        sizing="sm"
                                        optionsMode="aql"
                                        optionsSync2="false"
                                        service="tabela_versaos.index"
                                        optionsData="id_tabela_versao"
                                        :optionsParm="{ simpro: true }"
                                        optionsName="tabela_versaos.index.simpro"
                                        :optionsReload="true"
                                        label="Seleciona a versão"
                                        v-model="id_tabela_versao_sim"
                                        @input="itemTabela.id_simpro = null"
                                    />
                                </div>
                                <div class="col col-12 col-md-7" v-if="itemTabela.ch_tipo_atualizacao == 'S'">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Selecione o item..."
                                        label="Simpro"
                                        type="autocomplete"
                                        :validate="validate"
                                        optionsMode="aql"
                                        optionsData="id_simpro"
                                        :optionsParm="{ ativos: true, id_tabela_versao: id_tabela_versao_sim }"
                                        service="simpros.index"
                                        v-model="itemTabela.id_simpro" />
                                </div>
                                
                                <!-- dados da atualizarção -->
                                <div class="col col-12 col-md-2" v-if="itemTabela.ch_tipo_atualizacao">
                                    <az-input
                                        sizing="sm"
                                        label="Conversão de Unidade"
                                        :validate="validate"
                                        type="select"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        :optionsList="[
                                            { id: null, search: 'Não' },
                                            { id: 'D', search: 'Divisão' },
                                            { id: 'M', search: 'Multiplicação' },
                                        ]"
                                        v-model="itemTabela.ch_conversao_unidade" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="itemTabela.ch_tipo_atualizacao && itemTabela.ch_conversao_unidade">
                                    <az-input
                                        sizing="sm"
                                        label="Fator de Conversão"
                                        :precision="6"
                                        :validate="validate"
                                        type="money"
                                        v-model="itemTabela.dc_fator_conversao" />
                                </div>
                                <div class="col col-12 col-md-3" v-if="itemTabela.ch_tipo_atualizacao">
                                    <az-input
                                        sizing="sm"
                                        label="Valor"
                                        :validate="validate"
                                        type="select"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        :optionsList="opcoesAtualizacaoValores(itemTabela.ch_tipo_atualizacao)"
                                        v-model="itemTabela.ch_atualizacao_valor" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="itemTabela.ch_tipo_atualizacao">
                                    <az-input
                                        sizing="sm"
                                        label="Índice de atualização"
                                        :validate="validate"
                                        type="money"
                                        :precision="4"
                                        v-model="itemTabela.dc_indice_atualizacao">
                                        <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            
                                            <button class="btn btn-outline-primary" type="button" id="button-atualizacao-preco" 
                                                data-toggle="tooltip" data-placement="top" title="Verificar atualização"
                                                @click="atualizarPrecos()">
                                                <i class="fas fa-eye"></i>
                                            </button>

                                        </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3" v-if="itemTabela.ch_tipo_atualizacao">
                                    <small class="text-muted">Exemplo usando o Valor 10,00:</small>
                                    <br />
                                    <small class="text-info mt-4" v-if="itemTabela.ch_conversao_unidade && itemTabela.dc_fator_conversao > 0">
                                        ( 10,00
                                          {{ (itemTabela.ch_conversao_unidade == 'M' ? ' * ' : ' / ')}} 
                                          {{ $util.formatMoeda(itemTabela.dc_fator_conversao, 6, 2) }} 
                                        ) * {{ $util.formatMoeda(itemTabela.dc_indice_atualizacao, 6, 4) }} = 
                                        <template v-if="itemTabela.ch_conversao_unidade == 'M'">
                                            {{ $util.formatMoeda((10 * itemTabela.dc_fator_conversao) * itemTabela.dc_indice_atualizacao, 6, 2) }}
                                        </template>
                                        <template v-else>
                                            {{ $util.formatMoeda((10 / itemTabela.dc_fator_conversao) * itemTabela.dc_indice_atualizacao, 6, 2) }}
                                        </template>
                                    </small>
                                    <small class="text-info mt-3" v-else>
                                        {{ itemTabela.dc_valor }} * {{ itemTabela.dc_indice_atualizacao }} = 
                                        {{ itemTabela.dc_valor * itemTabela.dc_indice_atualizacao }}
                                    </small>
                                </div>
                            </div>

                            <div class="form-row" v-if="tabela.st_aplicacao != 'MIX'">
                                <div class="col col-12 col-md-4" v-if="!tabela.fl_moeda_corrente && itemTabela.moeda_corrente == 'N'">
                                    <az-input
                                        sizing="sm"
                                        type="money"
                                        label="Custo Operacional"
                                        :precision="3"
                                        :validate="validate"
                                        v-model="itemTabela.dc_custo_operacional" />
                                </div>
                                <div class="col col-12 col-md-4"  v-if="tabela.fl_tem_imagem">
                                    <az-input
                                        sizing="sm"
                                        icon="fas fa-x-ray"
                                        type="money"
                                        label="Filme"
                                        :precision="4"
                                        :validate="validate"
                                        v-model="itemTabela.dc_filme" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :optionsList="[
                                            { id: 'S', search: 'Não consolidar itens reduzidos com o Principal (Padrão)' },
                                            { id: 'N', search: 'Não consolidar itens reduzidos entre si de mesmo valor' },
                                            { id: 'A', search: 'Consolidar itens reduzidos com o principal' },
                                            { id: 'E', search: 'Consolidar itens e manter equipe' },
                                        ]"
                                        optionsData="id"
                                        label="Redução / Consolidação"
                                        :validate="validate"
                                        v-model="itemTabela.ch_reduc_agrupa" />
                                </div>
                            </div>

                            <template v-if="tabela && tabela.st_aplicacao == 'PRO'">
                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            label="Valor de Coparticipação"
                                            type="money"
                                            :validate="validate"
                                            v-model="itemTabela.dc_valor_copart" />
                                    </div>
                                
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Não definida..."
                                            label="Duração Procedimento (Guia)"
                                            type="number"
                                            :validate="validate"
                                            v-model="itemTabela.in_duracao">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <div class="input-group-text">
                                                        min
                                                    </div>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-12" :class="itemTabela.ch_valor_cooperado ? 'col-md-2' : 'col-md-4'">
                                        <az-input
                                            sizing="sm"
                                            label="Ação Valor de Cooperado"
                                            type="select"
                                            :optionsList="[
                                                { id: 'Z', search: 'Zerar Valor na Guia' },
                                                { id: 'H', search: 'Zerar Honorário na Guia' },
                                            ]"
                                            optionsData="id"
                                            :validate="validate"
                                            v-model="itemTabela.ch_valor_cooperado" />
                                    </div>

                                    <div class="col col-12 col-md-2" v-if="itemTabela.ch_valor_cooperado">
                                        <az-input
                                            sizing="sm"
                                            label="Valor Quando Cooperado (R$)"
                                            type="number"
                                            placeholder="Padrão..."
                                            :validate="validate"
                                            v-model="itemTabela.dc_valor_coop" />
                                    </div>
                                </div>
                            </template>

                            <!-- Cirurgia -->
                            <div class="form-row" v-if="tabela.fl_tem_cirurgia">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Porte Anestésico"
                                        :validate="validate"
                                        v-model="itemTabela.in_porte_anestesico" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Auxiliares"
                                        :validate="validate"
                                        v-model="itemTabela.in_numero_auxiliares" />
                                </div>
                                <div class="col col-12 col-md-4" v-if="itemTabela.in_porte_anestesico > 0">
                                    <az-input
                                        sizing="sm"
                                        type="money"
                                        label="Valor Anestesista"
                                        :validate="validate"
                                        v-model="itemTabela.dc_valor_anest" />
                                </div>
                            </div>

                            <div class="form-row" v-if="tabela.fl_tem_cirurgia || itemTabela.ch_tipo_guia">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        label="Tipo de Guia"
                                        sizing="sm"
                                        type="select"
                                        placeholder="Padrão..."
                                        optionsData="id"
                                        :optionsList="[
                                            {id: 'S', search: 'SP/SADT'},
                                            {id: 'H', search: 'Honorário Individual'},
                                            {id: 'R', search: 'Resumo de Internação'},
                                            {id: 'C', search: 'Consulta'}
                                        ]"
                                        :validate="validate"
                                        v-model="itemTabela.ch_tipo_guia" />
                                </div>

                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Equipe - Código do Prestador"
                                        placeholder="Padrão..."
                                        :validate="validate"
                                        v-model="itemTabela.st_cod_prestador" />
                                </div>
                            </div>

                            <template v-if="tabela.st_aplicacao == 'MIX'">
                                <az-sub-title class="mt-3" title="Outras Configurações"/>
                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Zerar o valor no arquivo/guia TISS"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tiss_zerado" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exportar item com valor zerado no arquivo TISS"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tiss_exportar_zerado" />
                                    </div>
                                </div>
                            </template>

                            <div class="mt-2" v-else-if="tabela && tabela.st_aplicacao == 'PRO'">
                                <div class="form-row" v-if="itemTabela.in_porte_anestesico">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Obrigar o lançamento do Anestesista no Atendimento"
                                            :validate="validate"
                                            v-model="itemTabela.fl_anest_obrig" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exibir a via de acesso na guia SP/SADT"
                                            :validate="validate"
                                            v-model="itemTabela.fl_via_na_guia" />
                                    </div>
                                    <div class="col col-12 col-md-4" v-if="itemTabela.fl_via_na_guia">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            placeholder="Selecione..."
                                            :optionsList="[
                                                {id: 'P', search: 'De acordo com a redução.'},
                                                {id: '1', search: 'Via Única (1)'},
                                                {id: '2', search: 'Mesma Via (2)'},
                                                {id: '3', search: 'Diferente Via (3)'}
                                            ]"
                                            optionsData="id"
                                            :validate="validate"
                                            v-model="itemTabela.ch_via_na_guia" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exibir a técnica convencional fixa na guia SP/SADT"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tec_na_guia" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Nunca acrescentar adicional de urgência"
                                            :validate="validate"
                                            v-model="itemTabela.fl_sem_ad_urg" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Não dobrar valor para acomodação apartamento"
                                            :validate="validate"
                                            v-model="itemTabela.fl_sem_dobrar_acomodacao" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Lançar Procedimento em Guia Separada"
                                            :validate="validate"
                                            v-model="itemTabela.fl_guia_separada" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Auxílios e demais membros zerados (valor total no procedimento principal)"
                                            :validate="validate"
                                            v-if="itemTabela.in_porte_anestesico || itemTabela.in_numero_auxiliares"
                                            v-model="itemTabela.fl_cirurg_membros_zerados" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Zerar o valor no arquivo TISS"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tiss_zerado" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Zerar o valor dos Materiais/Medicamentos no arquivo TISS - Guia de Outras Despesas"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tiss_zerado_consumos" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exportar item com valor zerado no arquivo TISS"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tiss_exportar_zerado" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exportar item como Taxa na Guia de Outras Despesas"
                                            :validate="validate"
                                            v-model="itemTabela.fl_tiss_procedimento_taxa" />

                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Não lançar na guia o procedimento zerado, quando tem outras despesas"
                                            :validate="validate"
                                            v-model="itemTabela.fl_nao_exportar_proc_zerado" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Informar data e hora (inicial e final) individual na guia"
                                            :validate="validate"
                                            :edicao="!itemTabela.fl_calcular_hora_final"
                                            v-model="itemTabela.fl_info_data" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Hora final corresponde à hora em que o procedimento foi finalizado no consultório"
                                            :validate="validate"
                                            v-model="itemTabela.fl_calcular_hora_final" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Não exibir identificação do profissional executante na guia"
                                            :validate="validate"
                                            v-model="itemTabela.fl_esconder_prof_exec" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Consolidar membros da equipe"
                                            :validate="validate"
                                            v-model="itemTabela.fl_consolidar_equipe" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Não gerar lançamentos de mat/med de solicitação para paciente (suprimentos)"
                                            :validate="validate"
                                            v-model="itemTabela.fl_block_estoque_consumo" />
                                    </div>
                                </div>
                            </div>

                            <template v-if="( !itemTabela.id_item_tabela || !itemTabela.total_procedimentos ) && itemTabela.exibir_vinculo">

                                <!-- MAT/MED -->

                                <template v-if="tabela.st_aplicacao == 'MIX'">

                                    <template v-if="!novo_procedimento">

                                        <az-sub-title class="mt-3" title="Vinculação Opcional"/>


                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    type="button-group"
                                                    :optionsList="[
                                                        { id: 'MAT', search: 'Material' },
                                                        { id: 'MED', search: 'Medicamento' },
                                                    ]"
                                                    optionsData="id"
                                                    optionsDisplay="search"
                                                    v-model="itemTabela.tipo" />

                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    v-if="itemTabela.tipo == 'MAT'"
                                                    key="id_mat"
                                                    sizing="sm"
                                                    placeholder="Seleção Opcional do Material"
                                                    type="autocomplete"
                                                    optionsMode="aql"
                                                    optionsName="materiais.index.ativos"
                                                    service="materiais.index"
                                                    :optionsParm="{ lista_cadastro: true, ativos: true }"
                                                    :optionsSync="false"
                                                    :optionsExternal="true"
                                                    v-model="itemTabela.material"
                                                    @selecionado="incluirProcedimento" />

                                                <az-input
                                                    key="id_med"
                                                    v-else
                                                    sizing="sm"
                                                    placeholder="Seleção Opcional do Medicamento"
                                                    type="autocomplete"
                                                    optionsMode="aql"
                                                    optionsName="medicamentos.index.ativos"
                                                    service="medicamentos.index"
                                                    :optionsParm="{ lista_cadastro: true, ativos: true }"
                                                    :optionsSync="false"
                                                    :optionsExternal="true"
                                                    v-model="itemTabela.medicamento"
                                                    @selecionado="incluirProcedimento" />
                                            </div>
                                        </div>

                                    </template>

                                    <template v-else>

                                        <az-sub-title class="mt-3" :title="'Incluir '+( itemTabela.tipo == 'MAT' ? 'Material' : 'Medicamento' )"/>
                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    v-if="itemTabela.tipo == 'MAT'"
                                                    sizing="sm"
                                                    label="Descrição"
                                                    placeholder="Descrição"
                                                    type="text"
                                                    v-model="novo_procedimento.st_material"
                                                    required
                                                    :validate="validate" />

                                                <az-input
                                                    v-else
                                                    sizing="sm"
                                                    label="Descrição"
                                                    placeholder="Descrição"
                                                    type="text"
                                                    v-model="novo_procedimento.st_medicamento"
                                                    required
                                                    :validate="validate" />
                                            </div>
                                        </div>

                                        <button class="btn btn-outline-danger btn-sm mt-2" type="button" @click="itemTabela.material = null; itemTabela.medicamento = null; novo_procedimento = null;">
                                            Cancelar Inclusão
                                        </button>

                                    </template>

                                </template>

                                <!-- Taxa -->

                                <template v-if="tabela.st_aplicacao == 'OUT'">

                                    <template v-if="!novo_procedimento">

                                        <az-sub-title class="mt-3" title="Vinculação Opcional"/>
                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Seleção Opcional da Taxa"
                                                    type="autocomplete"
                                                    optionsMode="aql"
                                                    optionsName="taxas.index.ativos"
                                                    service="taxas.index"
                                                    :optionsParm="{ lista_cadastro: true, ativos: true }"
                                                    :optionsSync="false"
                                                    :optionsExternal="true"
                                                    v-model="itemTabela.taxa"
                                                    @selecionado="incluirProcedimento" />
                                            </div>
                                        </div>

                                    </template>

                                    <template v-else>

                                        <az-sub-title class="mt-3" title="Incluir Taxa"/>
                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    sizing="sm"
                                                    label="Descrição da Taxa"
                                                    placeholder="Descrição da Taxa"
                                                    type="text"
                                                    v-model="novo_procedimento.st_taxa"
                                                    required
                                                    :validate="validate" />
                                            </div>
                                        </div>

                                        <button class="btn btn-outline-danger btn-sm mt-2" type="button" @click="novo_procedimento = null">
                                            Cancelar Inclusão
                                        </button>

                                    </template>

                                </template>

                                <!-- PROCEDIMENTOS -->

                                <template v-if="tabela.st_aplicacao == 'PRO'">

                                    <template v-if="!novo_procedimento">

                                        <az-sub-title class="mt-3" title="Vinculação Opcional"/>
                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    v-if="tabela"
                                                    sizing="sm"
                                                    placeholder="Seleção Opcional do Procedimento"
                                                    type="autocomplete"
                                                    optionsMode="aql"
                                                    optionsName="procedimentos.index.ativos"
                                                    service="procedimentos.index"
                                                    :optionsParm="{ lista_cadastro: true, ativos: true }"
                                                    :optionsSync="false"
                                                    :optionsExternal="true"
                                                    v-model="itemTabela.procedimento"
                                                    @selecionado="incluirProcedimento" />
                                            </div>
                                        </div>

                                        <div class="card mt-2" v-if="itemTabela.procedimento && itemTabela.procedimento.pits">
                                            <div class="card-header alert-warning">
                                                <i class="fas fa-exclamation-triangle"></i> Item já vinculado
                                            </div>
                                            <ul class="list-group">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(pit, ipx) in itemTabela.procedimento.pits" :key="ipx">
                                                    <div v-if="pit.item_tabela">
                                                        <a href="#" @click.prevent="abrirItemTabela(pit.id_item_tabela)" class="card-link h5 mb-0">
                                                            {{ pit.item_tabela.st_nome }}
                                                        </a>
                                                        
                                                        <div class="small">{{ pit.item_tabela.st_codigo }}</div>
                                                    </div>
                                                    <div>#{{ pit.id_item_tabela }}</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </template>

                                    <template v-else>

                                        <az-sub-title class="mt-3" title="Incluir Procedimento"/>
                                        <div class="form-row">
                                            <div class="col col-12">
                                                <az-input
                                                    sizing="sm"
                                                    label="Descrição do Procedimento"
                                                    placeholder="Descrição do procedimento"
                                                    type="text"
                                                    v-model="novo_procedimento.st_procedimento"
                                                    required
                                                    :validate="validate" />
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    sizing="sm"
                                                    label="Especialidade"
                                                    type="select"
                                                    optionsMode="esp-ativas"
                                                    optionsName="esp-ativas"
                                                    :optionsReload="true"
                                                    optionsData="id_especialidade"
                                                    v-model="novo_procedimento.id_especialidade"
                                                    required
                                                    :validate="validate" />
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    sizing="sm"
                                                    label="Classificação"
                                                    type="select"
                                                    optionsData="id_classe_procedimento"
                                                    service="classe_procedimentos.index"
                                                    optionsMode="aql"
                                                    v-model="novo_procedimento.id_classe_procedimento"
                                                    required
                                                    :validate="validate" />
                                            </div>
                                        </div>

                                        <button class="btn btn-outline-danger btn-sm mt-2" type="button" @click="novo_procedimento = null">
                                            Cancelar Inclusão
                                        </button>

                                    </template>

                                </template>

                            </template>

                            <div v-if="tabela.tabela_operadoras && tabela.tabela_operadoras.length">
                                <hr>
                                <az-sub-title title="Operadoras Relacionadas">
                                    <span class="badge badge-secondary">
                                        {{ tabela.tabela_operadoras.length }}
                                    </span>
                                </az-sub-title>
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(oper, iop) in tabela.tabela_operadoras" :key="iop">
                                        <a href='#' class="card-link h5 mb-0" @click.prevent="$util.abrirOperadora(oper.operadora)" v-if="!view">
                                            {{ oper.operadora.search }}
                                        </a>
                                        <span class="h5 mb-0" v-else>
                                            {{ oper.operadora.search }}
                                        </span>

                                        <a href='#' @click.prevent="exibir_moeda_corrente(itemTabela, oper)"
                                            v-if="itemTabela && itemTabela.id_item_tabela"
                                            data-toggle="tooltip" data-placement="top" title="Exibir em Moeda Corrente">
                                            <big>
                                                <i class="fas fa-search-dollar"></i>
                                            </big>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <!-- Items Vinculados / Procedimentos -->
                            <div v-if="itemTabela && itemTabela.procedimento_item_tabelas && itemTabela.procedimento_item_tabelas.length">
                                <az-sub-title class="mt-3" title="Procedimentos Vinculados">
                                    <span class="badge badge-secondary">
                                        {{ itemTabela.procedimento_item_tabelas.length }}
                                    </span>
                                </az-sub-title>
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(proc, iop) in itemTabela.procedimento_item_tabelas" :key="iop">
                                        <div>
                                            <s v-if="proc.del" class="h5 mb-0">
                                                {{ proc.procedimento.search }}
                                            </s>
                                            <a href='#' class="card-link h5 mb-0" @click.prevent="$util.abrirProcedimento(proc.procedimento)" v-else-if="!view">
                                                {{ proc.procedimento.search }}
                                            </a>
                                            <span class="h5 mb-0" v-else>
                                                {{ proc.procedimento.search }}
                                            </span>
                                        </div>
                                        <!-- Remover -->
                                        <div v-if="itemTabela.fl_ativo !== false">
                                            <button type="button" class="btn btn-sm" :class="proc.del ? 'btn-outline-success' : 'btn-outline-danger'" @click="proc.del = !proc.del">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true" v-if="!proc.del"></i>
                                                <i class="fa fa-plus fa-fw" aria-hidden="true" v-else></i>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <!-- Items Vinculados / Taxas -->
                            <div v-if="itemTabela && itemTabela.taxa_item_tabelas && itemTabela.taxa_item_tabelas.length">
                                <az-sub-title class="mt-3" title="Taxas Vinculados">
                                    <span class="badge badge-secondary">
                                        {{ itemTabela.taxa_item_tabelas.length }}
                                    </span>
                                </az-sub-title>
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(taxa, iop) in itemTabela.taxa_item_tabelas" :key="iop">
                                        <span class="h5 mb-0">
                                            {{ taxa.taxa.search }}
                                        </span>

                                        <!-- Remover -->
                                        <div>
                                            <button type="button" class="btn btn-sm" :class="taxa.del ? 'btn-outline-success' : 'btn-outline-danger'" @click="taxa.del = !taxa.del">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true" v-if="!taxa.del"></i>
                                                <i class="fa fa-plus fa-fw" aria-hidden="true" v-else></i>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <!-- Items Vinculados / Materiais -->
                            <div v-if="itemTabela && itemTabela.material_proprias && itemTabela.material_proprias.length">
                                <az-sub-title class="mt-3" title="Materiais Vinculados">
                                    <span class="badge badge-secondary">
                                        {{ itemTabela.material_proprias.length }}
                                    </span>
                                </az-sub-title>
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(item, iop) in itemTabela.material_proprias" :key="iop">
                                        {{ item.material.search }}
                                    </li>
                                </ul>
                            </div>

                            <!-- Items Vinculados / Medicamentos -->
                            <div v-if="itemTabela && itemTabela.medicamento_proprias && itemTabela.medicamento_proprias.length">
                                <az-sub-title class="mt-3" title="Medicamentos Vinculados">
                                    <span class="badge badge-secondary">
                                        {{ itemTabela.medicamento_proprias.length }}
                                    </span>
                                </az-sub-title>
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(item, iop) in itemTabela.medicamento_proprias" :key="iop">
                                        {{ item.medicamento.search }}
                                    </li>
                                </ul>
                            </div>

                            <br><br><br><br><br>

                            <pre v-if="1 == 0">{{ itemTabela }}</pre>

                        </template>
                    </div>
                    <div class="modal-footer" v-if="itemTabela">
                        <small v-if="itemTabela.id_item_tabela" class="small text-muted mr-3">#{{ itemTabela.id_item_tabela }}</small>
                        <az-audit-log-button model="itemTabela" :id="itemTabela.id_item_tabela" v-if="itemTabela.id_item_tabela" />
                        <az-audit-log-button model="propria" :id="itemTabela.id_propria" v-if="itemTabela.id_propria" />
                        <az-submit color="outline-danger" @click="removerItem ()" v-if="!view && !guiaedicao && itemTabela.fl_ativo !== false && ( itemTabela.id_item_tabela || itemTabela.id_propria )">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('itemModal')">Fechar</button>
                        <az-submit @click="atualizarItem ()" v-if="!view && itemTabela.fl_ativo !== false">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="valorCalculadoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Consultar Valor da Tabela
                            <span v-if="valor_calculado && valor_calculado.valor" class="badge badge-secondary ml-3">#{{ valor_calculado.valor.id }}</span>
                        </h5>
                        <button type="button" class="close" @click="fechar_modal('valorCalculadoModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!valor_calculado" />

                        <div v-if="valor_calculado">
                            <az-input
                                icon="far fa-credit-card fa-fw"
                                type="label"
                                :label="valor_calculado.operadora.search" />

                            <az-input
                                icon="fa fa-play fa-fw"
                                type="label"
                                :label="valor_calculado.item.search +
                                    ( valor_calculado.item.st_codigo ? ' / ' + valor_calculado.item.st_codigo : '' ) + 
                                    ( valor_calculado.item.st_codigo_autorizacao ? ' / Aut: ' + valor_calculado.item.st_codigo_autorizacao : '' )" />

                            <az-input
                                icon="fa fa-table fa-fw"
                                type="label"
                                :label="valor_calculado.item.tabela_versao.search" />

                            <az-input
                                v-if="valor_calculado.data"
                                icon="fa fa-calendar-o fa-fw"
                                type="label"
                                :label="$util.getFormatDate(valor_calculado.data) + ' ' + valor_calculado.data.substr(11,5) + ' / ' + getHumanDay(valor_calculado.data)" />

                            <az-input
                                type="label"
                                :label="$util.formatMoeda(valor_calculado.valor.valor)">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                </template>
                            </az-input>

                            <template v-if="valor_calculado && valor_calculado.item">
                                <span class="badge badge-warning mr-1" v-if="valor_calculado.item.fl_sem_ad_urg">
                                    Sem Adicional Urgência
                                </span>
                                <span class="badge badge-warning mr-1" v-if="valor_calculado.item.fl_sem_dobrar_acomodacao">
                                    Sem Dobrar Acomodação
                                </span>
                            </template>

                            <table class="table mt-3">
                                <thead>
                                    <tr>
                                        <th>Composição</th>
                                        <th>Moeda</th>
                                        <th class="text-right">Valor</th>
                                        <th class="text-right">Cotação</th>
                                        <th class="text-right">Valor (R$)</th>
                                    </tr>
                                </thead>
                                <!-- Porte -->
                                <tr v-if="valor_calculado.valor.porte">
                                    <td>{{ valor_calculado.valor.moeda == 'R$' ? 'Valor' : 'Porte' }}</td>
                                    <td>{{ valor_calculado.valor.moeda }}</td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(valor_calculado.valor.porte) }}
                                    </td>
                                    <td class="text-right">
                                        <template v-if="valor_calculado.valor.moeda != 'R$'">
                                            <div>{{ $util.formatMoeda(valor_calculado.valor.moeda_cotacao, 6) }}</div>
                                            <small class="text-muted">{{ valor_calculado.valor.moeda_cotacao_origem }}</small>
                                        </template>
                                    </td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_calculado.valor.valor_porte) }}</td>
                                </tr>

                                <!-- Adicional de Urgência -->
                                <tr v-if="valor_calculado.valor.valor_urg">
                                    <td>Adicional de Urgência</td>
                                    <td></td>
                                    <td class="text-right"></td>
                                    <td class="text-right"></td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_calculado.valor.valor_urg) }}</td>
                                </tr>

                                <!-- Custo Operacional -->
                                <tr v-if="valor_calculado.valor.custo_oper">
                                    <td>Custo Operacional</td>
                                    <td>UCO</td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(valor_calculado.valor.custo_oper) }}
                                    </td>
                                    <td class="text-right">
                                        <div>{{ $util.formatMoeda(valor_calculado.valor.custo_oper_cotacao) }}</div>
                                        <small class="text-muted">{{ valor_calculado.valor.custo_oper_cotacao_origem }}</small>
                                    </td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_calculado.valor.valor_custo) }}</td>
                                </tr>

                                <!-- Filme -->
                                <tr v-if="valor_calculado.valor.filme">
                                    <td>Filme</td>
                                    <td>Filme</td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(valor_calculado.valor.filme) }}
                                    </td>
                                    <td class="text-right">
                                        <div>{{ $util.formatMoeda(valor_calculado.valor.filme_cotacao) }}</div>
                                        <small class="text-muted">{{ valor_calculado.valor.filme_cotacao_origem }}</small>
                                    </td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_calculado.valor.valor_filme) }}</td>
                                </tr>

                            </table>

                        </div>

                        <pre v-if="1 == 0">{{ valor_calculado }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('valorCalculadoModal')">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        
        <tabela-atualizar-precos ref="tabelaAtualizarPrecos"/>

    </div>
</template>

<script>
import * as moment from "moment";
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import TabelaAtualizarPrecos from "../../cadastros/shared/TabelaAtualizarPrecos.vue";

export default {
    data () {
        return {
            itemTabela: null,
            tabela: null,
            callback: null,
            validate: false,
            incluir_procedimento: false,
            novo_procedimento: null,
            valor_calculado: null,
            id_tabela_versao_bra: null,
            id_tabela_versao_sim: null,
        }
    },

    components: {
        AzInput,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        AzEmptyState,
        TabelaAtualizarPrecos,
    },

    props: ['guiaedicao', 'view'],

    methods: {
        atualizarPrecos() {
            this.$refs.tabelaAtualizarPrecos.show('brasindice', this.itemTabela.st_codigo);
        },

        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },

        fechar_modal(modal) {
            $('#' + modal).modal('hide');
        },

        exibir_moeda_corrente (item, tabela_operadora, id_reducao = null, contexto = {}) {
            this.valor_calculado = null;

            $('#itemModal').modal('hide');
            $('#valorCalculadoModal').modal('show');

            this.$util.load(this, {
                service: 'item_tabelas',
                func: 'calcular_valor',
                parms: {
                    id: item.id_item_tabela,
                    id_operadora: tabela_operadora.id_operadora,
                    id_reducao: id_reducao,
                    ...contexto,
                },
                loadTo: res => {
                    this.valor_calculado = res;
                }
            });
        },

        incluirProcedimento(item) {

            if ( item && typeof item == 'string' ) {

                this.novo_procedimento = {
                    id_procedimento: null,
                    st_procedimento: item,
                    st_material: item,
                    st_medicamento: item,
                    st_taxa: item,
                    id_especialidade: "",
                    id_classe_procedimento: ""
                }

                this.itemTabela.procedimento = null;

            } else if ( this.itemTabela && this.itemTabela.procedimento && this.itemTabela.procedimento.id_procedimento ) {  

                this.$util.loadItem(this, { 
                    service: 'procedimento_item_tabelas',
                    func: 'index', 
                    parms: { 
                        id_tabela_versao: this.tabela.id_tabela_versao,
                        id_procedimento: this.itemTabela.procedimento.id_procedimento 
                    },
                })
                .then(res => { 
                    this.itemTabela.procedimento.pits = res;
                    this.$forceUpdate();
                });

            }

        },
        serviceName () {
            return ( this.tabela && this.tabela.st_aplicacao == 'MIX' ) ? 'proprias' : 'item_tabelas';
        },

        opcoesAtualizacaoValores(tipo) {
            if(tipo == "B") {
                return [
                    { id: '1', search: 'PFB' },
                    { id: '2', search: 'PFB Fracionado' },
                    { id: '3', search: 'PMC' },
                    { id: '4', search: 'PMC Fracionado' },
                ]
            } else {
                return [
                    { id: '1', search: 'Preço Fabrincante Embalagem' },
                    { id: '2', search: 'Preço Fabrincante Fracionado' },
                    { id: '3', search: 'Preço Venda Embalagem' },
                    { id: '4', search: 'Preço Venda Fracinado' },
                    { id: '5', search: 'Preço Usuário Embalagem' },
                    { id: '6', search: 'Preço Usuário Fracionado' },
                ]
            }
        },

        incluirItemParaModel (tabela, base, model, callback = null) {

            this.tabela = tabela;
            this.callback = callback;
            this.validate = false;
            this.novo_procedimento = null;
            this.itemTabela = null;

            console.log('base', base);

            let item = {
                id_item_tabela: null,
                id_tabela_versao: tabela.id_tabela_versao,
                fl_ativo: true,
                st_nome: base ? base['st_' + model] : "",
                st_descricao: base ? base['st_' + model] : "",
                st_codigo: "",
                dc_valor: 0,
                dc_valor_copart: 0, 
                dc_custo_operacional: 0,
                dc_filme: 0,
                id_moeda: null,
                exibir_vinculo: base ? false : true,
                ch_reduc_agrupa: 'P',
                ch_valor_cooperado: 'Z', 
            };

            item[model] = base;

            switch (model) {
                case 'material':
                    item.tipo = 'MAT';
                    break;

                case 'medicamento': 
                    item.tipo = 'MED';
                    break;
            }

            this.$nextTick(() => {
                this.itemTabela = { ...item };
                $('#itemModal').modal('show');
            });

        },

        incluirItemParaProcedimento (tabela, proc, callback = null) {

            this.tabela = tabela;
            this.callback = callback;
            this.validate = false;
            this.novo_procedimento = null;
            this.itemTabela = null;

            let item = {
                id_item_tabela: null,
                id_tabela_versao: tabela.id_tabela_versao,
                fl_ativo: true,
                st_nome: proc ? proc.st_procedimento : "",
                st_codigo: "",
                dc_valor: 0,
                dc_custo_operacional: 0,
                dc_filme: 0,
                id_moeda: null,
                procedimento: { ...proc },
                exibir_vinculo: proc ? false : true,
                ch_reduc_agrupa: 'P',
                ch_valor_cooperado: 'Z', 
            };

            this.$nextTick(() => {
                this.itemTabela = { ...item };
                $('#itemModal').modal('show');
            });

        },

        incluirItem (tabela, callback = null) {

            this.itemTabela = null;
            this.tabela = tabela;
            this.callback = callback;
            this.validate = false;
            this.novo_procedimento = null;

            let item;

            if ( tabela.st_aplicacao == 'MIX' ) {

                item = {
                    id_propria: null,
                    id_tabela_versao: tabela.id_tabela_versao,
                    fl_ativo: true,
                    st_descricao: "",
                    st_codigo: "",
                    dc_valor: 0,
                    exibir_vinculo: true,
                    tipo: "MAT",
                };

            } else {

                item = {
                    id_item_tabela: null,
                    id_tabela_versao: tabela.id_tabela_versao,
                    fl_ativo: true,
                    st_nome: "",
                    st_codigo: "",
                    dc_valor: 0,
                    dc_custo_operacional: 0,
                    dc_filme: 0,
                    id_moeda: null,
                    procedimento: null,
                    exibir_vinculo: true,
                    id_especialidade: "",
                    id_grau_participacao: "",
                    ch_reduc_agrupa: 'P',
                    ch_valor_cooperado: 'Z', 
                };

            }

            this.$nextTick (() => {
                this.itemTabela = { ...item };
                $('#itemModal').modal('show');
            });

        },

        atualizarItem () {

            this.$util.atualizar(this, {
                service: this.serviceName(),
                dados: {
                    ...this.itemTabela,
                    novo_procedimento: this.novo_procedimento,
                },
                modal: 'itemModal',
                callback: this.callback,
            })
        },

        abrirItemTabela (id, callback = null, tabela = null) {

            this.validate = false;
            this.itemTabela = null;
            this.tabela = tabela;
            this.callback = callback;
            this.novo_procedimento = null;

            this.$store.commit('loading', true);

            $('#itemModal').modal('show');

            let listaWith = [
                (this.serviceName() == 'item_tabelas' ? 'itemTabelaPreco' : 'tabelaVersao'),
                'tabelaVersao.tabelaOperadoras:id_tabela_operadora,id_tabela_versao,id_operadora',
                'tabelaVersao.tabelaOperadoras.operadora:id_operadora,st_operadora',
            ];

            if(this.serviceName() == 'proprias') {
                listaWith.push('brasindice:id_brasindice,id_tabela_versao');
                listaWith.push('simpro:id_simpro,id_tabela_versao');
            }

            this.$nextTick (() => {
                this.$util.loadItem (this, {
                    service: this.serviceName(),
                    id: id,
                    parms: {
                        cadastro: true,
                    },
                    with: listaWith,
                })
                .then (res => {
                    this.tabela = { ...res.tabela_versao };
                    this.itemTabela = { ...res };

                    if ( this.itemTabela.item_tabela_preco && this.itemTabela.item_tabela_preco.fl_ativo && this.itemTabela.item_tabela_preco.dt_vigencia_inicio <= this.$util.hoje() ) {
                        this.itemTabela.dc_valor = this.itemTabela.item_tabela_preco.dc_valor;
                        this.itemTabela.item_tabela_preco = null;
                    }

                    if ( !res.total_procedimentos ) {
                        this.itemTabela.exibir_vinculo = true;
                    }

                    this.id_tabela_versao_bra = _.get(res, 'brasindice.id_tabela_versao');
                    this.id_tabela_versao_sim = _.get(res, 'simpro.id_tabela_versao');
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });
            });

        },

        removerItem () {
            if ( !confirm ('Confirma remover item da tabela?') )
                return;

            this.$util.remover(this, {
                service: this.serviceName(),
                dados: this.itemTabela,
                modal: 'itemModal',
                callback: this.callback,
            });
        },

    }
}
</script>
